import React from "react";
import SwapVertIcon from "@mui/icons-material/SwapVert";

const ScopeChanges = ({ sprint, stories }) => {
  // Use sprint metadata if backend provides it, else derive from stories
  const storiesAdded   = sprint?.storiesAdded   ?? stories.filter((s) => s.addedAfterStart).length;
  const storiesRemoved = sprint?.storiesRemoved ?? 0;
  const pointsAdded    = sprint?.pointsAdded    ?? 0;
  const pointsRemoved  = sprint?.pointsRemoved  ?? 0;

  const rows = [
    { label: "Stories Added",   value: `+${storiesAdded}`,    color: "#16a34a" },
    { label: "Stories Removed", value: `-${storiesRemoved}`,  color: "#ef4444" },
    { label: "Points Added",    value: `+${pointsAdded} SP`,  color: "#16a34a" },
    { label: "Points Removed",  value: `-${pointsRemoved} SP`,color: "#ef4444" },
  ];

  return (
    <div style={{
      background:"#fff", borderRadius:12, border:"1px solid #e5e7eb",
      boxShadow:"0 1px 4px rgba(0,0,0,.06)", padding:"16px 18px", height:"100%"
    }}>
      {/* Header */}
      <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:12 }}>
        <SwapVertIcon sx={{ fontSize:16, color:"#8b5cf6" }} />
        <div>
          <div style={{ fontSize:13, fontWeight:700, color:"#111827" }}>Scope Changes</div>
          <div style={{ fontSize:11, color:"#9ca3af" }}>Since sprint start</div>
        </div>
      </div>

      {/* Rows */}
      {rows.map((item, i) => (
        <div key={i} style={{
          display:"flex", justifyContent:"space-between", alignItems:"center",
          padding:"8px 0", borderBottom: i < rows.length - 1 ? "1px solid #f3f4f6" : "none"
        }}>
          <span style={{ fontSize:12, color:"#6b7280" }}>{item.label}</span>
          <span style={{ fontSize:13, fontWeight:700, color: item.color }}>{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export default ScopeChanges;
